import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Icon } from "../Icon";
import { COMPANY, INQUIRY_TYPES, PARTNER_TYPE } from "../data";
import { CRITERIA, MESSAGES } from "../content";
import { SEGMENTS } from "../segments";
import { ContactForm, PageHero, PARTNER_LINK, useSeo } from "../ui";

/* =========================================================
   /contact — 개발 문의
   일반 개발 의뢰와 공동개발(Partnership) 문의를 한 폼으로 받는다 (예전 /apply 는 여기로 넘어온다).
   ?type=<문의 유형> — 서비스 페이지에서 유형을 골라 둔 채로 넘어온다
   ?segment=<세그먼트 id> · ?gov=1 — 공동개발 문의를 고르고 업종을 미리 채운다
   ========================================================= */
export default function Contact() {
  const [params] = useSearchParams();
  const seg = SEGMENTS.find((s) => s.id === params.get("segment"))
    || (params.get("gov") ? SEGMENTS.find((s) => s.id === "funded") : null);
  const asked = params.get("type");
  const presetType = seg ? PARTNER_TYPE : INQUIRY_TYPES.includes(asked) ? asked : "";
  useSeo({
    title: "개발 문의 — 개발 의뢰 · 공동개발 문의 | I.META",
    description:
      "회로 · PCB · 펌웨어 · 서버 · 웹사이트 제작 등 개발 의뢰와 공동개발(Partnership) 문의를 한곳에서 받습니다. 개발 의뢰는 영업일 기준 1일, 공동개발 문의는 검토 후 1주 이내 연락드립니다. idotmeta@gmail.com · 010-9601-4161",
    path: "/contact",
  });

  return (
    <>
      <PageHero
        kicker="CONTACT"
        title="개발 문의"
        desc="개발 의뢰도, 공동개발 문의도 여기로 보내주세요. 개발 의뢰는 영업일 기준 1일 안에 회신드립니다."
      />

      <section className="section section--tight">
        <div className="contact contact--page">
          <div className="contact__text">
            <div className="contact__panel contact__panel--accent">
              <h2 className="contact__panel-title">{MESSAGES.support.invest}</h2>
              <p className="contact__panel-note">
                문의 유형에서 '{PARTNER_TYPE}'를 고르면 공동개발 심사로 검토합니다. 심사 기준은 아래와 같습니다.
              </p>
              <ol className="criteria criteria--mini">
                {CRITERIA.map((c, i) => (
                  <li key={c} className="criteria__item">
                    <span className="criteria__no">{i + 1}</span>
                    <span className="criteria__text">{c}</span>
                  </li>
                ))}
              </ol>
              {presetType !== PARTNER_TYPE && (
                <Link to={PARTNER_LINK} className="btn btn--primary btn--block">
                  공동개발 문의로 쓰기 <Icon.ArrowRight width="16" height="16" aria-hidden="true" focusable="false" />
                </Link>
              )}
              <p className="contact__panel-note">
                상담 전 비밀유지계약(NDA)을 체결할 수 있습니다. <Link to="/partnership">공동개발 보기</Link>
              </p>
            </div>

            <div className="contact__panel">
              <h2 className="contact__panel-title">바로 연락</h2>
              <div className="contact__row">
                <span className="contact__label">
                  <Icon.Mail width="18" height="18" aria-hidden="true" focusable="false" /> 이메일
                </span>
                <a className="contact__value" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
              </div>
              <div className="contact__row">
                <span className="contact__label">
                  <Icon.Phone width="18" height="18" aria-hidden="true" focusable="false" /> 전화
                </span>
                <a className="contact__value" href={`tel:${COMPANY.phone.replace(/-/g, "")}`}>{COMPANY.phone}</a>
              </div>
              <p className="contact__panel-note">
                공동개발 관련 내용은 <Link to="/partnership#faq">자주 묻는 질문</Link>에 정리되어 있습니다.
              </p>
            </div>
          </div>

          <ContactForm
            key={`${presetType}|${seg?.id || ""}`}
            defaultType={presetType}
            defaultSegment={seg?.label || ""}
          />
        </div>
      </section>
    </>
  );
}
